import React, { useContext, useState } from "react";

import { toast } from "react-toastify";

import { AppContext } from "../../AppContext";
import {
  setUserCredentials,
  setAuthOnlyCredentials,
} from "../../utils/common";
import {
  authenticateSupportCredentials,
  esvSupportLogin,
  mapSupportLoginSession,
} from "../../actions/login";

import Login from "./Login";
import SupportCompanyStep from "./SupportCompanyStep";

export default function SupportLoginFlow({ history }) {
  const context = useContext(AppContext);
  const [step, setStep] = useState("credentials");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firebaseIdToken, setFirebaseIdToken] = useState(null);
  const [companyLoginLoading, setCompanyLoginLoading] = useState(false);

  const handleCredentialsSuccess = (data, credentials) => {
    setEmail(credentials.email);
    setPassword(credentials.password);
    setFirebaseIdToken(data.firebase_id_token);
    setAuthOnlyCredentials({
      firebase_id_token: data.firebase_id_token,
      firebase_refresh_token: data.firebase_refresh_token,
      expires_in: data.expires_in ? String(data.expires_in) : "",
      user_email: credentials.email,
    }, context);
    setStep("company");
  };

  const handleCompanyLogin = async ({ companyName, companyDomain, userPayload }) => {
    if (userPayload === undefined || userPayload === null) {
      toast.error("Unable to resolve access for the selected company. Please contact support.");
      return;
    }

    setCompanyLoginLoading(true);
    try {
      const result = await esvSupportLogin(
        email,
        password,
        companyName,
        companyDomain,
        firebaseIdToken,
      );

      if (!result.success) {
        toast.error(result.data || "Support login failed.");
        return;
      }

      const sessionData = mapSupportLoginSession(
        result.data,
        companyName,
        companyDomain,
        userPayload,
      );

      setUserCredentials("session", {
        ...sessionData,
        expires_in: sessionData.expires_in ? String(sessionData.expires_in) : "",
        uid: "support",
        user_title: "Admin",
      }, context);

      history.push("/sample-submission");
    } finally {
      setCompanyLoginLoading(false);
    }
  };

  if (step === "credentials") {
    return (
      <Login
        history={history}
        variant="support"
        authenticateFn={authenticateSupportCredentials}
        onCredentialsSuccess={handleCredentialsSuccess}
      />
    );
  }

  return (
    <SupportCompanyStep
      firebaseIdToken={firebaseIdToken}
      userEmail={email}
      onLogin={handleCompanyLogin}
      loginLoading={companyLoginLoading}
      history={history}
    />
  );
}
